const ensureStructure = window => {
  window.digitalData = window.digitalData || {}
  window.digitalData.page = window.digitalData.page || {}
  window.digitalData.event = window.digitalData.event || []
  window.digitalData.track = window.digitalData.track || (() => {})
}

const componentIdFromMediaSource = mediaSource => {
  const assetNameMatch = /\w+$/g.exec(mediaSource)

  return assetNameMatch && assetNameMatch.index ? assetNameMatch[0] : mediaSource
}

const componentIdFromMediaItem = mediaItem => {
  return componentIdFromMediaSource(mediaItem.src)
}

const fire = (index = 0, interactionType, componentID, window) => {
  ensureStructure(window)

  const componentPosition = index + 1

  const event = {
    eventInfo: {
      eventName: 'pdp_mediaPlayerInteraction',
      eventAction: 'PDP Media Player Interaction'
    },
    attributes: {
      componentID,
      interactionType,
      componentPosition
    }
  }

  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName)
  return window.digitalData
}

export default {
  componentIdFromMediaItem,
  componentIdFromMediaSource,
  ensureStructure,
  fire
}
